import { PageHeader, ProfileEditor } from 'src/components';

export function ProfilePage() {
  return (
    <section className="flex flex-col max-w-right-section mx-auto px-6 xl:px-0">
      <PageHeader
        title="Profile"
        description="This information shown here is only visible to you."
      />
      <ProfileEditor />
    </section>
  );
}
